<template>

  <div id='footer-wrapper' v-if="context" :class="($vuetify.breakpoint.mobile) ? 'px-2': ''">

    <template v-for="(oneFooter, index) in context">
      <dynamic-section
          :key="index"
          :context="oneFooter"
      />
    </template>

    <img src="https://abc.herbalgram.org/site/PixelServer">

  </div>

</template>
<script>
import DynamicSection from "@/components/DynamicSection";
import globalMixins   from "@/mixins/globalMixins";
import "@/styles/footer.sass";

export default {
  name: 'Footer',
  props: {
    context: {
      type: Array
    }
  },

  components: {
    DynamicSection
  },

  mixins: [ globalMixins ],

  async created() {
    if ( this.context ) {
      await this.checkFixProperties( this.context, true );
    }
  }
}
</script>
<style>

</style>